import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import DriverFormCard from "./driverForm/driverFormCard";
import ReservationDetailsContainer from "./reservationDetailsContainer";
import ReservationStickyButton from "./reservation/reservationStickyButton";
import { container } from "tsyringe";
import { notifyCheckOutCompleteHook } from "../../hooks/notifyCheckOutCompleteHook";
import { InvitationTrustPilot } from "../../../domain/model/CheckOut/InvitationTrustPilot";
import { getCookieByID } from "../../hooks/getCookie";
import * as Sentry from "@sentry/react";
const DetailsContainer = ({ myData, images, collections, formData, rate, componentType, applyDiscount, t, userUFP, localCurrency, setLocalCurrency, localCurrencyVisible, setLocalCurrencyVisible, completeReservation, setCompleteReservation, ip, dataSplitPayment, searchParams, setEmail, email, orderNumber, setOrderNumber, userAnalyzer, isAllInclusiveOffer, onAllInclusiveOfferChange, allInclusiveOffer, standardOffer }) => {
    var _a, _b, _c, _d, _e, _f;
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 960);
    const [reservationConfirmation, setReservationConfirmation] = useState(null);
    const [operationEnded, setOperationEnded] = useState(false);
    const [reservationComplete, setReservationComplete] = useState(false);
    const [showCheckout, setShowCheckout] = useState(false);
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [paymentData, setPaymentData] = useState({
        paymentMethodBrand: "visa",
        paymentMethodType: "card",
        paymentMethodData: "1234",
    });
    const url = new URLSearchParams(window.location.search);
    const [onlyOnDestination, setOnlyOnDestination] = useState(url.get("paymentOnDestination") ? url.get("paymentOnDestination") == "true" : false);
    const _BookingServices = container.resolve("IBookingServices");
    const createInvitationTrustPilot = container.resolve("iUseCaseCreateInvitationTrustPilot");
    const _orderStatusService = container.resolve("IGetOrderStatusService");
    let imagesDesktop = [];
    const _logger = container.resolve("ILogger");
    const wsConfirmedRef = useRef(false);
    /*const videoMiniatures = [
      {
        url: "https://cdn.shopify.com/s/files/1/0816/6431/1592/files/Video-Thumbnail-1.png?v=1720647230",
        type: "video",
        videoURL:
          "https://cdn.shopify.com/videos/c/o/v/efe68053c25449cfb53e0f9f79a91cfe.mp4",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0816/6431/1592/files/Video-Thumbnail-2.png?v=1720647230",
        type: "video",
        videoURL:
          "https://cdn.shopify.com/videos/c/o/v/e5ee4bbb394e41caa24aec95b56cdb5e.mp4",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0816/6431/1592/files/Video-Thumbnail-3.png?v=1720647230",
        type: "video",
        videoURL:
          "https://cdn.shopify.com/videos/c/o/v/705690c3ea164e299f63d4947c14a7d4.mp4",
      },
    ];*/
    const driverFormData = isAllInclusiveOffer && allInclusiveOffer ? allInclusiveOffer : standardOffer || myData;
    const parseRotatorImages = (value) => {
        if (!value)
            return [];
        if (Array.isArray(value)) {
            return value.map((img) => String(img || "").trim()).filter(Boolean);
        }
        if (typeof value === "string") {
            const raw = value.trim();
            if (!raw)
                return [];
            if (raw.startsWith("[") && raw.endsWith("]")) {
                try {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) {
                        return parsed.map((img) => String(img || "").trim()).filter(Boolean);
                    }
                }
                catch (_a) {
                    // Ignore and fallback to CSV parsing.
                }
            }
            const splitByHttp = raw
                .split(/,(?=\s*https?:\/\/)/i)
                .map((img) => img.trim().replace(/^"+|"+$/g, ""))
                .filter(Boolean);
            if (splitByHttp.length > 1)
                return splitByHttp;
            if (/^https?:\/\//i.test(raw))
                return [raw.replace(/^"+|"+$/g, "")];
            return [];
        }
        return [];
    };
    const expandRotatorFramesFromSeed = (seedUrl) => {
        const clean = String(seedUrl || "").trim();
        const match = clean.match(/^(.*_)(\d{3})(\.[^/?#]+(?:\?[^#]*)?)$/i);
        if (!match)
            return clean ? [clean] : [];
        const [, prefix, , suffix] = match;
        return [45, 90, 135, 180, 225, 270, 315, 360].map((angle) => `${prefix}${String(angle).padStart(3, "0")}${suffix}`);
    };
    const buildMediaKey = (item) => {
        if (typeof item === "string")
            return item;
        if ((item === null || item === void 0 ? void 0 : item.type) === "rotator") {
            const rotatorFrames = parseRotatorImages(item === null || item === void 0 ? void 0 : item.images).join("|");
            return `rotator:${rotatorFrames}`;
        }
        return `${(item === null || item === void 0 ? void 0 : item.type) || ""}:${(item === null || item === void 0 ? void 0 : item.url) || ""}`;
    };
    //if the videoMiniatures are not in the imagesUrl array, add them using a for each loop
    /*videoMiniatures.forEach((video) => {
      if (!imagesDesktop.includes(video)) {
        imagesDesktop.push(video);
      }
    });*/
    const normalizedInputImages = Array.isArray(images)
        ? images
        : (typeof images === "string"
            ? parseRotatorImages(images).map((url) => ({ type: "image", url }))
            : []);
    normalizedInputImages.forEach((image) => {
        if (typeof image === "string") {
            const hasImage = imagesDesktop.some((item) => buildMediaKey(item) === image);
            if (!hasImage)
                imagesDesktop.push(image);
            return;
        }
        const normalizedType = String((image === null || image === void 0 ? void 0 : image.type) || "").toLowerCase();
        const declaredAsRotator = normalizedType.includes("rotator");
        const framesFromImages = parseRotatorImages(image === null || image === void 0 ? void 0 : image.images);
        const framesFromUrl = parseRotatorImages(image === null || image === void 0 ? void 0 : image.url);
        const rotatorFrames = framesFromImages.length
            ? framesFromImages
            : (declaredAsRotator || framesFromUrl.length > 1 ? framesFromUrl : []);
        const finalRotatorFrames = declaredAsRotator && rotatorFrames.length <= 1 && (image === null || image === void 0 ? void 0 : image.url)
            ? expandRotatorFramesFromSeed(image.url)
            : rotatorFrames;
        const isRotator = declaredAsRotator || finalRotatorFrames.length > 0;
        // 360 disabled for now. Keep this block to re-enable quickly.
        // if (image.type === "360") {
        //   imagesDesktop.push({
        //     type: "360",
        //     url: `https://cdn.holacarrentals.com/?image=${image.url}`,
        //   });
        //   return;
        // }
        if (image.type === "360") {
            return;
        }
        const normalizedImage = isRotator
            ? {
                type: "rotator",
                images: finalRotatorFrames,
                url: image.url || finalRotatorFrames[0] || "",
            }
            : image.url;
        const hasImage = imagesDesktop.some((item) => buildMediaKey(item) === buildMediaKey(normalizedImage));
        if (!hasImage) {
            if (isRotator) {
                imagesDesktop.push({
                    type: "rotator",
                    images: finalRotatorFrames,
                    url: image.url || finalRotatorFrames[0] || "",
                });
            }
            else {
                imagesDesktop.push(image.url);
            }
        }
    });
    imagesDesktop.reverse();
    //remove duplicates from the imagesDesktop array
    imagesDesktop = imagesDesktop.filter((item, index, self) => {
        const key = buildMediaKey(item);
        return index === self.findIndex((candidate) => {
            const candidateKey = buildMediaKey(candidate);
            return candidateKey === key;
        });
    });
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 960);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        document.body.classList.toggle("--open-checkout", isOpen);
        return () => {
            document.body.classList.remove("--open-checkout");
        };
    }, [isOpen]);
    const customData = {
        timestamp: new Date().toISOString(),
        id: myData.id,
        token: formData.idSession,
        url: window.location.href,
        client_id: formData.userId,
        email: sessionStorage.getItem("email"),
        phone: sessionStorage.getItem("phone"),
        first_name: sessionStorage.getItem("name"),
        last_name: "",
        address1: myData.pickUpLocation.locationName,
        address2: "",
        city: myData.pickUpLocation.locationCode,
        country: sessionStorage.getItem("country"),
        countryCode: myData.pickUpLocation.locationCode,
        province: "",
        provinceCode: "",
        orderId: formData.transactionId,
        currency: ((_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.currency.active)
            ? (_b = window.Shopify) === null || _b === void 0 ? void 0 : _b.currency.active
            : sessionStorage.getItem("currency"),
        value: (_f = (_e = (_d = (_c = myData.pricesDetail) === null || _c === void 0 ? void 0 : _c.currency) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.total) === null || _f === void 0 ? void 0 : _f.baseAmount,
        car: myData.car,
        renter: myData.renter.renterName,
        totalRentDays: myData.totalRentDays,
        _ga: getCookieByID("_ga"),
    };
    const handleReservationComplete = (data) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        wsConfirmedRef.current = true;
        setOperationEnded(true);
        setReservationComplete(data.successfulProcess);
        if (data.firstName !== undefined) {
            customData.first_name = data.firstName + (data.lastName ? " " + data.lastName : "");
        }
        if (data.email !== undefined) {
            customData.email = data.email;
        }
        if (data.phone !== undefined) {
            customData.phone = data.phone;
        }
        if (data.orderId !== undefined) {
            setOrderNumber(data.orderId);
            customData.orderId = data.orderId;
        }
        else {
            customData.orderId = formData.transactionId;
        }
        //add to the actual url a param calle tnk with a value of 1 if its no already present, do this withouth reloading the page
        if (!window.location.search.includes("tnk=1")) {
            window.history.pushState({}, "", `${window.location}&tnk=1`);
        }
        setLoadingCheckout(false);
        setPaymentData(data);
        // Push order_confirmed event to dataLayer only when the renter confirms the reservation
        if (data.successfulProcess) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "order_confirmed",
                transaction_id: customData.orderId || formData.transactionId,
                ecommerce: {
                    currency: formData.currency || "USD",
                    value: Number(customData.value || 0),
                    items: [{
                            item_id: String((_a = myData === null || myData === void 0 ? void 0 : myData.id) !== null && _a !== void 0 ? _a : ""),
                            item_name: ((_b = myData === null || myData === void 0 ? void 0 : myData.car) === null || _b === void 0 ? void 0 : _b.name) || "",
                            affiliation: "Holacar rentals Store",
                            item_brand: ((_c = myData === null || myData === void 0 ? void 0 : myData.renter) === null || _c === void 0 ? void 0 : _c.renterName) || "",
                            item_category: ((_d = myData === null || myData === void 0 ? void 0 : myData.pickUpLocation) === null || _d === void 0 ? void 0 : _d.locationCity) || formData.city || "",
                            item_category2: ((_e = myData === null || myData === void 0 ? void 0 : myData.car) === null || _e === void 0 ? void 0 : _e.sippCode) || "",
                            item_category3: ((_f = myData === null || myData === void 0 ? void 0 : myData.car) === null || _f === void 0 ? void 0 : _f.sizeName) || "",
                            price: Number(customData.value || 0),
                            quantity: 1,
                        }],
                },
            });
        }
        notifyCheckOutCompleteHook(customData, _logger);
        var invitationTrustPilot = new InvitationTrustPilot();
        invitationTrustPilot.recipientEmail = `${customData.email}`;
        invitationTrustPilot.recipientName = `${(_g = customData.first_name) !== null && _g !== void 0 ? _g : ""} ${(_h = customData.last_name) !== null && _h !== void 0 ? _h : ""}`;
        invitationTrustPilot.referenceId = formData.transactionId;
        invitationTrustPilot.source = "InvitationScript";
        invitationTrustPilot.tags = ["paid Of Destination"];
        createInvitationTrustPilot.handle(invitationTrustPilot).then((data) => { });
    };
    /**
     * Function to get PayPal payment intent from storage
     * @returns {Array} - Array containing a boolean indicating if PayPal intent exists and the intent ID
     */
    const getPaymentPaypal = () => {
        var _a;
        const data = (_a = localStorage.getItem("payment_method")) !== null && _a !== void 0 ? _a : '{}';
        const { value, expiration, id = null } = JSON.parse(data);
        if (expiration && new Date().getTime() < expiration && value === 'paypal') {
            return id;
        }
        localStorage.removeItem("payment_method"); // Remove expired or invalid entry
        return null;
    };
    useEffect(() => {
        _BookingServices.validateReservationComplete((data) => {
            const idPaypal = getPaymentPaypal();
            if (idPaypal !== null) {
                _BookingServices.paymentStatus({ IntentPaymentId: idPaypal, }, null, (paymentStatus) => {
                    var _a;
                    const isCompleted = (_a = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.IsCompleted) !== null && _a !== void 0 ? _a : paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.isCompleted;
                    if (!isCompleted) {
                        return;
                    }
                    handleReservationComplete(data);
                });
            }
            else {
                handleReservationComplete(data);
            }
        });
    }, []);
    useEffect(() => {
        _BookingServices.validateReservationComplete((data) => {
            var _a;
            if (data.paymentMethodType == "paypal") {
                _BookingServices.paymentStatus({ IntentPaymentId: (_a = sessionStorage.getItem("checkout_intent_id_paypal")) !== null && _a !== void 0 ? _a : "", }, null, (paymentStatus) => {
                    var _a;
                    const isCompleted = (_a = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.IsCompleted) !== null && _a !== void 0 ? _a : paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.isCompleted;
                    if (!isCompleted) {
                        return;
                    }
                    handleReservationComplete(data);
                });
            }
            else {
                handleReservationComplete(data);
            }
        });
    }, []);
    useEffect(() => {
        if (myData.status !== 1) {
            setLoadingCheckout(true);
            setShowCheckout(true);
        }
    }, [myData.status]);
    // Fallback polling: if WebSocket confirmation doesn't arrive within 20s,
    // poll the orders API up to 3 times (5s apart) looking for a confirmation_number.
    // If found → show confirmation. If not after 3 attempts → show pending screen.
    useEffect(() => {
        if (!loadingCheckout || operationEnded)
            return;
        const INITIAL_DELAY_MS = 20000;
        const POLL_INTERVAL_MS = 5000;
        const MAX_ATTEMPTS = 3;
        let cancelled = false;
        const pollOrderStatus = async () => {
            for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
                if (cancelled || wsConfirmedRef.current)
                    return;
                _logger.log(`Checkout fallback poll attempt ${attempt}/${MAX_ATTEMPTS}`);
                try {
                    const order = await _orderStatusService.getByTransactionId(formData.transactionId);
                    if (cancelled || wsConfirmedRef.current)
                        return;
                    if (order && order.confirmed) {
                        _logger.log(`Checkout fallback: confirmation found via API — ${order.confirmation_number}`);
                        handleReservationComplete({
                            successfulProcess: true,
                            firstName: order.customer_name,
                            lastName: order.last_name,
                            email: order.customer_email || order.email,
                            phone: order.customer_phone,
                            orderId: order.order_number || order.name,
                            paymentMethodType: order.paymentMethodType || "card",
                            paymentMethodBrand: order.paymentMethodBrand || "",
                            paymentMethodData: order.paymentMethodData || "",
                        });
                        return;
                    }
                }
                catch (err) {
                    _logger.log(`Checkout fallback poll error: ${err}`);
                    Sentry.captureException(err, {
                        tags: { component: "DetailsContainer", context: "checkout-fallback-poll" },
                    });
                }
                if (attempt < MAX_ATTEMPTS && !cancelled && !wsConfirmedRef.current) {
                    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
                }
            }
            // All attempts exhausted without confirmation — show pending screen
            if (!cancelled && !wsConfirmedRef.current) {
                _logger.log("Checkout fallback: no confirmation after 3 attempts — showing pending screen");
                setLoadingCheckout(false);
                setOperationEnded(true);
                setReservationComplete(false);
            }
        };
        const timeout = setTimeout(pollOrderStatus, INITIAL_DELAY_MS);
        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };
    }, [loadingCheckout, operationEnded]);
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"; // Disable automatic scroll restoration
        }
    }, []);
    const labelFunction = () => {
        let element = document.querySelector("#root");
        window.history.pushState(null, document.title);
        //scroll to top smooth
        if (element != null) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        setIsOpen(true);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "detail", children: [_jsx("div", { className: "detail__transactions", children: _jsx(_Fragment, { children: _jsx(DriverFormCard, { dataSplitPayment: dataSplitPayment, myData: driverFormData, formData: formData, npm: true, rate: rate, collection: collections, isOpen: isOpen, setIsOpen: setIsOpen, reservationConfirmation: reservationConfirmation, reservationComplete: reservationComplete, setReservationConfirmation: setReservationConfirmation, setOperationEnded: setOperationEnded, operationEnded: operationEnded, orderNumber: orderNumber, showCheckout: showCheckout, setShowCheckout: setShowCheckout, loadingCheckout: loadingCheckout, setLoadingCheckout: setLoadingCheckout, paymentData: paymentData, t: t, userUFP: userUFP, localCurrency: localCurrency, setLocalCurrency: setLocalCurrency, localCurrencyVisible: localCurrencyVisible, setLocalCurrencyVisible: setLocalCurrencyVisible, completeReservation: completeReservation, setCompleteReservation: setCompleteReservation, shouldHide: searchParams.get("offerId") ? true : false, onlyOnDestination: onlyOnDestination, setOnlyOnDestination: setOnlyOnDestination, ip: ip, setEmail: setEmail, email: email, setPaymentData: setPaymentData, userAnalyzer: userAnalyzer, isAllInclusiveOffer: isAllInclusiveOffer, onAllInclusiveOfferChange: onAllInclusiveOfferChange, allInclusiveOffer: allInclusiveOffer, standardOffer: standardOffer }) }) }), _jsx(ReservationDetailsContainer, { myData: myData, formData: formData, collections: collections, images: images, rate: rate, componentType: componentType, showCheckout: showCheckout, setShowCheckout: setShowCheckout, operationEnded: operationEnded, applyDiscount: applyDiscount, imagesDesktop: imagesDesktop, localCurrency: localCurrency, completeReservation: completeReservation, setCompleteReservation: setCompleteReservation, onlyOnDestination: onlyOnDestination, shouldHide: searchParams.get("offerId") ? true : false, t: t, allInclusiveOffer: allInclusiveOffer })] }), searchParams.get("offerId")
                ? null
                : (_jsx(ReservationStickyButton, { myData: myData, formData: formData, rate: rate, collection: collections, setIsOpen: setIsOpen, isOpen: isOpen, labelFunction: labelFunction, t: t }))] }));
};
export default DetailsContainer;
